module.exports = __webpack_public_path__ + "img/avatar.cba5de91.jpg";